module.exports = __webpack_public_path__ + "img/lxbn_vip.97498304.png";